module.exports = __webpack_public_path__ + "static/media/LogoIntal_Transparente.9c528cd6.png";